<div class="d-flex justify-content-center container-fluid">
  <router-outlet></router-outlet>
</div>
